import { QueryCache } from '@tanstack/react-query';
/** This is exported for @weenat/client internal use. Do not export to inside index & do not use inside app, instead use queryClient */
const queryCache = new QueryCache();
export default queryCache;
